import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '../../shared/model/pagination.model';
import { ApiService } from './api.service';
import { JobApplication, JobApplicationData, JobVacancy } from '../../shared/model/jobs.model';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class JobsService {

  private authlessService = 'recruitment-http';
  private service = 'recruitment-http/recruitment';
  private module = 'jobs';

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private languageService: LanguageService,
  ) { }

  getJobVacancyList(paginate?: Partial<Pagination> | Partial<JobVacancy>) {
    return this.apiService.get(this.authlessService, 'authless/v1/' + this.module + '/vacancy', { ...paginate, lang: this.languageService.getLang() });
  }

  getJobVacancyBySlug(slug: string) {
    return this.apiService.get(this.authlessService, 'authless/v1/' + this.module + `/vacancy/${ slug }`, { lang: this.languageService.getLang() });
  }

  applyJob(jobVacancyId: number) {
    return this.apiService.post(this.service, 'api/v1/' + this.module + `/${ jobVacancyId }/apply`);
  }

  getJobApplicationStatus(jobVacancySlug: string) {
    return this.apiService.get(this.service, 'api/v1/' + this.module + `/${ jobVacancySlug }/application/status`);
  }

  submitJobApplication(jobApplicationId: number, data: Partial<JobApplicationData>[]) {
    return this.apiService.post(this.service, 'api/v1/' + this.module + `/application/${ jobApplicationId }/submit`, data);
  }

  getJobApplicationDraft(jobApplicationId: number) {
    return this.apiService.get(this.service, 'api/v1/' + this.module + `/application/${ jobApplicationId }/draft`);
  }

  saveDraftJobApplication(jobApplicationId: number, data: Partial<JobApplicationData>[]) {
    return this.apiService.post(this.service, 'api/v1/' + this.module + `/application/${ jobApplicationId }/draft`, data);
  }

  autofillJobApplicationFromCv(jobApplicationId: number, data: { file_path: string; auto_parse: boolean }) {
    return this.apiService.post(this.service, 'api/v1/' + this.module + `/application/${ jobApplicationId }/cv-autofill`, data);
  }

  getJobApplicationList(data?: Partial<JobApplication>, paginate?: Partial<Pagination>) {
    return this.apiService.get(this.service, 'api/v1/' + this.module + '/application', { ...data, ...paginate });
  }

  getJobApplicationDetail(jobApplicationId: number, paginate?: Partial<Pagination>) {
    return this.apiService.get(this.service, 'api/v1/' + this.module + `/application/${ jobApplicationId }`, paginate);
  }

  deleteJobApplication(jobApplicationId: number) {
    return this.apiService.delete(this.service, 'api/v1/' + this.module + `/application/${ jobApplicationId }`);
  }

  getJobApplicationData(jobApplicationId: number, rawData = false) {
    return this.apiService.get(this.service, 'api/v1/' + this.module + `/application/${ jobApplicationId }/data`, { raw: rawData });
  }

  getMissingRequiredFields(jobApplicationId: number) {
    return this.apiService.get(this.service, 'api/v1/' + this.module + `/application/${ jobApplicationId }/missing-required-fields`);
  }

  resubmitJobApplication(jobApplicationId: number, data: Partial<JobApplicationData>[]) {
    return this.apiService.post(this.service, 'api/v1/' + this.module + `/application/${ jobApplicationId }/resubmit`, data);
  }
}
